import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LauncherComponent } from './launcher/launcher.component';
import { ApplicantLandingComponent } from './applicant-landing/applicant-landing.component';
import { ApplicantLearnmoreComponent } from './applicant-learnmore/applicant-learnmore.component';
import { ProctorLearnmoreComponent } from './proctor-learnmore/proctor-learnmore.component';
import { ProctorLandingComponent } from './proctor-landing/proctor-landing.component';
import { RouterModule } from '@angular/router';
import { CreateArticlesComponent } from './create-articles/create-articles.component';
import { LearnmoreDisplayComponent } from './learnmore-display/learnmore-display.component';
import { UiPartialModule } from '../ui-partial/ui-partial.module';
import { HttpClientModule } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { ContactusComponent } from './contactus/contactus.component';
import { NewsComponent } from './news/news.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { LegalComponent } from './legal/legal.component';
import { SampleQuestionsPreComponent } from './sample-questions-pre/sample-questions-pre.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { UiLoginModule } from '../ui-login/ui-login.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule, 
    ReactiveFormsModule,
    UiPartialModule,
    UiLoginModule,
    HttpClientModule,
    MarkdownModule,
  ],
  declarations: [
    LauncherComponent, 
    ApplicantLandingComponent, 
    ApplicantLearnmoreComponent, 
    ProctorLearnmoreComponent, 
    ProctorLandingComponent, 
    CreateArticlesComponent, 
    LearnmoreDisplayComponent, 
    ContactusComponent, 
    NewsComponent, 
    PrivacyComponent, 
    LegalComponent, 
    SampleQuestionsPreComponent, 
    LoginComponent, 
    LogoutComponent,
    ForgotPasswordComponent,
  ],
  exports: [
  ]
})
export class UiLandingModule { }
